import { CONFIG } from '@/config';

// Set axios default base URL if axios is available
if (typeof window !== 'undefined' && (window as any).axios) {
  (window as any).axios.defaults.baseURL = CONFIG.BACKEND_BASE;
}

// Patch global fetch to rewrite relative /api/* to absolute URLs
const origFetch = window.fetch.bind(window);
window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
  const url = typeof input === 'string' ? input : (input as Request).url;
  if (/^\/api\//.test(url)) {
    const abs = `${CONFIG.BACKEND_BASE}${url}`;
    if (typeof input === 'string') return origFetch(abs, init);
    const req = new Request(abs, input as RequestInit);
    return origFetch(req, init);
  }
  return origFetch(input as any, init);
};

console.log('[network] Global fetch patched for absolute API URLs');
console.log('[network] API base:', CONFIG.BACKEND_BASE);
